import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { STATIC_ROUTES } from '../../../../constants/routes';
import { useAuth } from '../../../../container/authContext';
import { partialUpdateTaskService } from '../../../../services/tasks';
import { isResponseOk } from '../../../../utility/isResponseOk';
import TaskAccessSettings, { toAccessSettingsBody, toAccessSettingsState } from '../../components/forms/TaskAccessSettings';

/**
 * The "Access Settings" tab of a task: the same setting the task modal offers,
 * changed on its own after the task exists.
 */
const AccessSettingsTab = ({ task, setTask }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { company: { id: companyID } = {} } = user;

  const [formData, setFormData] = useState(() => toAccessSettingsState(task.access_settings));
  const [errors, setErrors] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  // The task is reloaded when the page is; the tab follows it.
  useEffect(() => {
    setFormData(toAccessSettingsState(task.access_settings));
  }, [task.access_settings]);

  const handleSave = async () => {
    try {
      setIsSaving(true);
      setErrors(null);

      const response = await partialUpdateTaskService({ access_settings: toAccessSettingsBody(formData) }, task.id);

      if (isResponseOk(response) && response.data) {
        setTask((prevState) => ({ ...prevState, access_settings: response.data.access_settings }));
        toast('The access settings were saved successfully', {
          icon: () => <img src="/images/full-check-circle.svg" />,
          closeButton: ({ closeToast }) => (
            <button onClick={closeToast} className="btn btn-icon close-alert-btn">
              <img src="/images/x-icon.svg" />
            </button>
          ),
          className: 'task-deleted-alert',
          toastClassName: 'task-deleted-alert-wrapper',
          autoClose: 5000,
          hideProgressBar: false,
          progress: undefined,
          theme: 'light',
          closeOnClick: true,
          pauseOnHover: true,
          type: 'success',
        });
      } else {
        setErrors(response?.response?.data?.access_settings || null);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="task-details-tab-content">
      <div className="task-settings-tab task-access-settings-tab">
        <div className="task-settings-tab-header">
          <h1>{task.name}</h1>
        </div>

        <TaskAccessSettings companyId={companyID} value={formData} onChange={setFormData} errors={errors} showTitle={false} />
      </div>

      <div className="form-control-actions">
        <button className="btn btn-outline" onClick={() => navigate(STATIC_ROUTES.TASKS)}>
          Close
        </button>
        <button className="btn" onClick={handleSave} disabled={isSaving}>
          {isSaving ? 'Saving...' : 'Save'}
        </button>
      </div>
    </div>
  );
};

export default AccessSettingsTab;
